<template>
  <div class="computed-field-cell text-ellipsis">
    <div class="flex-center" v-if="error">
      <i :id="'cf-error-' + uuid" class="warning-circle-icon"></i>
      <tooltip key="error-tooltip" :show-delay="800" :target="'cf-error-' + uuid">{{
        error.message
      }}</tooltip>
    </div>
    <div class="text-ellipsis" :class="{ pill: isPill }" v-else-if="isValidValue">
      <span class="text-small-1" :id="'value-' + uuid">{{ value }}</span>
      <tooltip key="value-tooltip" :show-delay="1000" :target="'value-' + uuid"
        >The value({{ value }}) of this field is automatically calculated</tooltip
      >
    </div>
    <div class="text-secondary text-center" :class="{ pill: isPill }" :id="'empty-' + uuid" v-else>
      <span>&nbsp;</span>
      <tooltip key="empty-tooltip" :show-delay="1000" :target="'empty-' + uuid"
        >Calculated field is missing as one of the fields it depends on is empty, check
        formula</tooltip
      >
    </div>
  </div>
</template>

<script>
import * as R from 'ramda'
import Tooltip from '@/components/Tooltip.vue'
import ComponentIdMixin from '@/mixins/ComponentIdMixin'

/**
 * This shows the value for computed custom field.
 * If it has an error, it shows the error icon and tooltip to display the error message.
 */
export default {
  name: 'ComputedFieldValue',
  mixins: [ComponentIdMixin],
  components: { Tooltip },
  props: ['value', 'error', 'isPill'],
  computed: {
    isValidValue() {
      return !R.isEmpty(this.value) && !R.isNil(this.value)
    }
  },
  methods: {}
}
</script>

<style scoped lang="scss">
@import '~@/styles/_styleConfigurations.scss';

.pill {
  border-radius: 20px;
  min-width: 40px;
  height: 25px;
  padding: 0 10px;
  display: flex;
  align-items: center;
  background-color: $quaternary;
  cursor: default;
}
</style>
